import { useEffect, useState, useCallback } from "react";
import { getCategories } from "../Utils/categoryApi";

// Single source of truth for course category names — replaces the
// hardcoded arrays previously duplicated across course create/edit/browse pages.
export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getCategories();
      setCategories((response.data.categories || []).map((c) => c.name));
    } catch (err) {
      setError(err.message);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return { categories, loading, error };
};
